var _a;
import { createActions } from 'redux-actions';
export var setIdentity = (_a = createActions('SET_IDENTITY', 'SET_IDENTITY_COMPLETE'), _a.setIdentity), setIdentityComplete = _a.setIdentityComplete;
